
document.addEventListener('DOMContentLoaded', function() {
  /* ---------------------------
     Variant background color
  --------------------------- */
  const section = document.querySelector('.product-image-with-text');
  const useVariantBg =
    section && section.getAttribute('data-use-variant-bg') === 'true';

  if (section && useVariantBg) {
    function updateBackground() {
      const selectedInput = document.querySelector(
        '.variant-picker__option-values input[type="radio"]:checked'
      );
      if (!selectedInput) return;

      const label = document.querySelector('label[for="' + selectedInput.id + '"]');
      if (!label) return;

      const style = label.getAttribute('style') || '';
      const match = style.match(/#([A-Fa-f0-9]{3,8})/);
      if (match) {
        section.style.backgroundColor = match[0];
      }
    }

    updateBackground();

    document.addEventListener('change', function(e) {
      if (
        e.target.matches(
          '.variant-picker__option-values input[type="radio"]'
        )
      ) {
        setTimeout(updateBackground, 50);
      }
    });
  }

  /* ---------------------------
     Image slider: native swipe + dots
  --------------------------- */
  function initImageSlider(slider) {
    const track = slider.querySelector('[data-image-slider-track]');
    const slides = slider.querySelectorAll('[data-image-slider-slide]');
    const dots = slider.querySelectorAll('[data-image-slider-dot]');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let isScrolling = false;

    function setActiveDot(index) {
      if (!dots.length) return;
      dots.forEach(function(dot, i) {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function scrollToIndex(index) {
      const maxIndex = slides.length - 1;
      if (index < 0) index = 0;
      if (index > maxIndex) index = maxIndex;

      const width = track.clientWidth || 1;
      track.scrollTo({
        left: width * index,
        behavior: 'smooth'
      });

      currentIndex = index;
      setActiveDot(currentIndex);
    }

    // Click on dots
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        scrollToIndex(index);
      });
    });

    // Update dots when user swipes / scrolls
    function onScroll() {
      if (isScrolling) return;
      isScrolling = true;

      window.requestAnimationFrame(function() {
        const width = track.clientWidth || 1;
        const scrolled = track.scrollLeft;
        const index = Math.round(scrolled / width);

        if (index !== currentIndex) {
          currentIndex = index;
          setActiveDot(currentIndex);
        }

        isScrolling = false;
      });
    }

    track.addEventListener('scroll', onScroll);

    // Keep slide aligned on resize
    window.addEventListener('resize', function() {
      const width = track.clientWidth || 1;
      track.scrollLeft = width * currentIndex;
    });

    // Initial state
    setActiveDot(0);
    track.scrollLeft = 0;
  }

  document
    .querySelectorAll('[data-image-slider]')
    .forEach(initImageSlider);
});
